import { queryOptions, useQuery } from "@tanstack/react-query";
import { fetchCmmsVendors } from "../clients/cmmsClient";

export const cmmsVendorsQueryOptions = () =>
  queryOptions({
    queryKey: ["cmms-vendors"],
    queryFn: fetchCmmsVendors,
    // Vendor schemas change only when cmms_field_definitions.py ships.
    staleTime: 10 * 60_000,
    meta: { errorMessage: "CMMS vendors could not be loaded." },
  });

export function useCmmsVendors() {
  return useQuery(cmmsVendorsQueryOptions());
}
